import { useState, useEffect } from "react";
import { Box, Text } from "@chakra-ui/react";

const RelojTiempoReal = () => {
  const [hora, setHora] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => {
      setHora(new Date());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <Box 
      textAlign="initial" 
      color="black" 
      fontSize="3xl" 
      fontWeight="bold" 
    //   fontFamily="monospace" // Asegura un ancho fijo para cada número
      minW="200px" // Fija el ancho del reloj para evitar movimientos
      maxW={[ "200px"]} // Ajusta el ancho en pantallas pequeñas
    >
      <Text>{hora.toLocaleTimeString()}</Text>
    </Box>
  );
};

export default RelojTiempoReal;
